import { useFetch } from "../../hooks/useFetch";
import { Loading, EmptyState } from "../../components/States";
import { PageHeader } from "../../components/PageHeader";
import { StatusPill } from "../../components/StageBar";
import { CalendarClock, ShieldCheck, Phone, User } from "lucide-react";

export default function Service() {
  const appointments = useFetch("/appointments");
  const warranty = useFetch("/warranty");
  if (appointments.loading || warranty.loading) return <Loading />;

  return (
    <div className="space-y-8">
      <PageHeader eyebrow="Residential Service" title="Service" subtitle="Homeowner appointments and warranty callbacks." />
      <div className="grid gap-6 lg:grid-cols-2">
        <div>
          <h3 className="mb-4 flex items-center gap-2 font-head text-xl font-bold text-white"><CalendarClock size={18} className="text-cyan-400" /> Appointments</h3>
          <div className="space-y-3">
            {(appointments.data || []).length === 0 && <EmptyState title="No appointments" icon={CalendarClock} />}
            {(appointments.data || []).map((a) => (
              <div key={a.id} className="hw-card p-5 hw-rise" data-testid={`appointment-${a.id}`}>
                <div className="flex items-start justify-between">
                  <div className="font-semibold text-white">{a.service_type}</div>
                  <StatusPill status={a.status} />
                </div>
                <div className="mt-3 space-y-1 text-sm text-slate-400">
                  <div className="flex items-center gap-2"><CalendarClock size={14} /> {new Date(a.scheduled_date).toLocaleDateString()} · {a.window}</div>
                  <div className="flex items-center gap-2"><User size={14} /> {a.technician}</div>
                  <div className="flex items-center gap-2"><Phone size={14} /> {a.address}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div>
          <h3 className="mb-4 flex items-center gap-2 font-head text-xl font-bold text-white"><ShieldCheck size={18} className="text-cyan-400" /> Warranty Tickets</h3>
          <div className="space-y-3">
            {(warranty.data || []).length === 0 && <EmptyState title="No warranty tickets" icon={ShieldCheck} />}
            {(warranty.data || []).map((w) => (
              <div key={w.id} className="hw-card p-5 hw-rise" data-testid={`warranty-${w.id}`}>
                <div className="flex items-start justify-between">
                  <div>
                    <div className="font-mono2 text-xs text-cyan-400">{w.ticket}</div>
                    <div className="mt-1 font-semibold text-white">{w.title}</div>
                  </div>
                  <StatusPill status={w.status} />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
